import React from "react"
import ReactDOM from "react-dom"
import SearchBar from "./component/searchBar"
import OpenOverlayButton from "./component/openOverlayButton"
import TypeaheadOverlay from "./component/typeaheadOverlay"
import searchService from "./services/searchService"

export default class TypeaheadModule {
  constructor(elem) {
    this.elem = elem
    this.headerSearchBar = document.querySelector(".js-typeahead-module-header")
    this.topmenuSearchBar = document.querySelector(".js-typeahead-module-topmenu")
    this.mobileSearchBar = document.querySelector(".js-typeahead-module-mobile")
    this.config = elem.dataset
    this.typeaheadConfig = JSON.parse(this.config.typeaheadConfig)
    this.timer = undefined
    this.searchBar = (
      <SearchBar autoFocus={true} onKeyUp={this.handleKeyUp} handleInput={(e) => this.handleInput(e)} placeholderText={this.config.placeholderText} />
    )
    this.init()
    return this
  }

  createPageData(data) {
    const displayGroupNames = {}
    var count = 0
    if (data) {
      for (var propName in data) {
        displayGroupNames[propName] = data[propName].displayGroupName
        if (data[propName].count === 0) {
          data[propName].docs = {}
        } else {
          count += data[propName].count
        }
      }

      return {
        filteredData: data,
        displayGroupNames: displayGroupNames,
        totalCount: count,
        config: this.typeaheadConfig,
      }
    }
    return this.createZeroState()
  }

  createZeroState() {
    return {
      filteredData: undefined,
      displayGroupNames: undefined,
      totalCount: 0,
      config: undefined,
    }
  }

  handleResults(results, searchTerm) {
    const data = this.createPageData(results)
    ReactDOM.render(<TypeaheadOverlay data={data} query={searchTerm} />, this.elem)
  }

  openEmptyOverlay() {
    this.handleResults()
  }

  handleInput(e) {
    let searchTerm = e.value

    if (this.timer) {
      window.clearTimeout(this.timer)
    }

    this.timer = setTimeout(
      () => searchService.performSearch(searchTerm, this.config.queryConfig).then((results) => this.handleResults(results?.data, searchTerm)),
      1000,
    )
  }

  finalizeSearch(searchTerm) {
    searchService.redirectToSearchpage(searchTerm)
  }

  handleKeyUp(e) {
    if (e.key === "Enter") {
      searchService.redirectToSearchpage(e.currentTarget.value)
    }
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.unmountComponentAtNode(this.headerSearchBar)
    ReactDOM.unmountComponentAtNode(this.topmenuSearchBar)
    ReactDOM.unmountComponentAtNode(this.mobileSearchBar)
    ReactDOM.render(<SearchBar onFocus={(e) => this.openEmptyOverlay(e)} placeholderText={this.config.placeholderText} />, this.headerSearchBar)
    ReactDOM.render(<OpenOverlayButton onClick={(e) => this.openEmptyOverlay(e)} type={"topmenu"} />, this.topmenuSearchBar)
    ReactDOM.render(<OpenOverlayButton onClick={(e) => this.openEmptyOverlay(e)} type={"mobile"} />, this.mobileSearchBar)
    ReactDOM.render(
      <TypeaheadOverlay data={this.createZeroState()} searchBar={this.searchBar} onFinalSearch={(searchTerm) => this.finalizeSearch(searchTerm)} />,
      this.elem,
    )
  }
}
